import { NgModule } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { CoreFiltersModule } from '../../../core/core.filters.module';
import { PriorityTextPipe } from './pipes/priority.text.pipe';
import { GfFilterRangeFrom } from './pipes/range.from.pipe';
import { GfFilterRangeTo } from './pipes/range.to.pipe';
import { StatusTextFilter } from './pipes/status.text.pipe';
import { EfErrorMessagePipe } from './pipes/ef.error.message.pipe';

import { CoreWidgetsModule } from '../../../widgets/core.widgets.module';

import { ExtraFieldRendererComponent } from './trackerItemFields/extraFieldRenderer/extra.field.renderer.component';
import { TrackerQueriesDropdownComponent } from './trackerQueriesDropdown/tracker.queries.dropdown.component';
import { TrackerItemLockComponent } from './trackerItemLock/trackeritem.lock.component';
import { ExtraFieldsListComponent } from './trackerItemFields/extraFieldsList/extra.fields.list.component';
import { TrackerItemFieldsComponent } from './trackerItemFields/trackeritem.fields.component';

import { TibAssigneesComponent } from './tibAssignee/trackeritem.browse.assignee.component';
import { TibAssigneesSmComponent } from './tibAssignee/trackeritem.browse.assignee-sm.component';
import { AssigneeHelperService } from './tibAssignee/trackeritem.browse.assignee.helper';

import { AssigneesSelectorComponent } from './assigneesSelector/assignees.selector.component';
import { AssociationsComponent } from './associations/associations.component';
import { AssociationAddModalComponent } from './associations/associationAddModal/association.add.modal.component';

import { CsvUploadComponent } from './csv/csvUpload/csvUpload.component';
import { CsvHelpComponent } from './csv/csvHelp/csvhelp.component';
import { CsvResultComponent } from './csv/csvResult/csvresult.component';

import { TrackeritemBrowseListComponent } from './trackerItemBrowse/trackerItemBrowseList/trackeritem.browse.list.component';
import { TrackeritemMultiUpdateModalComponent } from './trackeritemMultiUpdateModal/trackeritem.multi.update.modal.component';
import { TrackeritemMultiDeleteModalComponent } from './trackeritemMultiDeleteModal/trackeritem.multi.delete.modal.component';
import { TrackeritemBrowseToolbarComponent } from './trackerItemBrowse/trackerItemBrowseToolbar/trackeritem.browse.toolbar.component';

import { AdHocFilterDateComponent } from './adHocFilters/adHocFilterDate/adhoc.filter.date.component';
import { AdHocFilterSelectComponent } from './adHocFilters/adHocFilterSelect/adhoc.filter.select.component';
import { AdHocFilterTextComponent } from './adHocFilters/adHocFilterText/adhoc.filter.text.component';
import { AdHocFiltersComponent } from './adHocFilters/adhoc.filters.component';

import { TrackeritemValidationFailuresModalComponent } from './trackerItemValidationsModal/trackeritem.validations.modal.component';

import { RenderTiTextDirective } from './renderTiText/render.ti.text.directive';
import { DuplicatesComponent } from './duplicates/duplicates.component';

import { TrackeritemMoveModalComponent } from './trackeritemMoveModal/trackeritem.move.component';
import { TrackeritemCloneModalComponent } from './trackeritemCloneModal/trackeritem.clone.component';

import { AssigneesFilterComponent } from './assigneesFilter/assignees.filter.component';
import { TrackeritemBrowseComponent } from './trackerItemBrowse/trackeritem.browse.component';
import { TrackerQueryEmbeddableComponent } from '../../../widgets/wiki/trackerQueryEmbeddable/tracker.query.embeddable.component';

@NgModule({
    imports: [
      CommonModule,
      CoreWidgetsModule,
      CoreFiltersModule,
      FormsModule
    ],
    providers:  [
      AssigneeHelperService,
      Location
    ],
    declarations: [
      EfErrorMessagePipe,
      PriorityTextPipe,
      GfFilterRangeFrom,
      GfFilterRangeTo,
      StatusTextFilter,
      ExtraFieldRendererComponent,
      TrackerQueriesDropdownComponent,
      TrackerItemLockComponent,
      ExtraFieldsListComponent,
      TibAssigneesComponent,
      TibAssigneesSmComponent,
      AssigneesSelectorComponent,
      TrackeritemBrowseListComponent,
      AssociationsComponent,
      AssociationAddModalComponent,
      CsvUploadComponent,
      CsvHelpComponent,
      CsvResultComponent,
      TrackeritemMultiUpdateModalComponent,
      TrackeritemMultiDeleteModalComponent,
      TrackeritemBrowseToolbarComponent,
      AdHocFilterDateComponent,
      AdHocFilterSelectComponent,
      AdHocFilterTextComponent,
      AdHocFiltersComponent,
      TrackeritemValidationFailuresModalComponent,
      TrackerItemFieldsComponent,
      RenderTiTextDirective,
      DuplicatesComponent,
      TrackeritemMoveModalComponent,
      TrackeritemCloneModalComponent,
      AssigneesFilterComponent,
      TrackeritemBrowseComponent,
      TrackerQueryEmbeddableComponent
    ],
    exports: [
      EfErrorMessagePipe,
      PriorityTextPipe,
      GfFilterRangeFrom,
      GfFilterRangeTo,
      StatusTextFilter,
      ExtraFieldRendererComponent,
      TrackerQueriesDropdownComponent,
      TrackerItemLockComponent,
      ExtraFieldsListComponent,
      TibAssigneesComponent,
      TibAssigneesSmComponent,
      AssigneesSelectorComponent,
      TrackeritemBrowseListComponent,
      AssociationsComponent,
      AssociationAddModalComponent,
      CsvUploadComponent,
      CsvHelpComponent,
      CsvResultComponent,
      TrackeritemMultiUpdateModalComponent,
      TrackeritemMultiDeleteModalComponent,
      TrackeritemBrowseToolbarComponent,
      AdHocFilterDateComponent,
      AdHocFilterSelectComponent,
      AdHocFilterTextComponent,
      AdHocFiltersComponent,
      TrackeritemValidationFailuresModalComponent,
      TrackerItemFieldsComponent,
      RenderTiTextDirective,
      DuplicatesComponent,
      TrackeritemMoveModalComponent,
      TrackeritemCloneModalComponent,
      AssigneesFilterComponent,
      TrackeritemBrowseComponent,
      TrackerQueryEmbeddableComponent
    ],
})
export class TrackerLibModule {
    constructor() { }
}
